<template>
  <button
    v-bind="$attrs"
    ref="triggerRef"
    :aria-label="props.label"
    class="text-center w-full active:bg-[#5dcbf4] active:text-white xl:bg-none xl:active:bg-inherit xl:active:text-inherit"
    @mouseenter="show"
    @mouseleave="hide"
  >
    <div
      class="icon p-1 xl:bg-white xl:border xl:border-gray-400 xl:rounded-full xl:hover:border-gray-500 xl:transition-colors"
    >
      <i v-if="props.iconClass" :class="props.iconClass" class="fal" />
    </div>
    <div
      class="label xl:text-black mt-0.5 font-medium text-xs whitespace-nowrap overflow-visible"
    >
      {{ props.label }}
    </div>
  </button>
  <Teleport to="body">
    <div
      v-if="props.tooltip && visible"
      ref="tipRef"
      class="fr-tooltip fixed bg-fr-light-blue text-white rounded text-xs p-2 shadow-lg whitespace-nowrap pointer-events-none"
      :style="tooltipStyle"
    >
      {{ props.tooltip }}
    </div>
  </Teleport>
</template>

<script setup>
import { ref, computed, nextTick } from "vue";

defineOptions({ inheritAttrs: false });

const props = defineProps({
  label: {
    type: String,
    default: null,
  },
  iconClass: {
    type: String,
    default: null,
  },
  tooltip: {
    type: String,
    default: null,
  },
});

const triggerRef = ref(null);
const tipRef = ref(null);
const visible = ref(false);
const pos = ref({ top: 0, left: 0 });

const tooltipStyle = computed(() => ({
  top: `${pos.value.top}px`,
  left: `${pos.value.left}px`,
  zIndex: 9999,
}));

async function show() {
  if (!props.tooltip) return;
  visible.value = true;
  await nextTick();
  updatePosition();
}

function hide() {
  visible.value = false;
}

function updatePosition() {
  const trigger = triggerRef.value;
  const tip = tipRef.value;
  if (!trigger || !tip) return;
  const rect = trigger.getBoundingClientRect();

  let left = rect.left + rect.width / 2 - tip.offsetWidth / 2;
  const top = rect.bottom + 8;

  if (left < 4) left = 4;
  if (left + tip.offsetWidth > window.innerWidth - 4) {
    left = window.innerWidth - tip.offsetWidth - 4;
  }

  pos.value = { top, left };
}
</script>

<style lang="scss" scoped>
.active {
  .icon {
    background-color: #5dcbf4; // $selectedColor;
    color: white;
  }
}
</style>

<style>
.fr-tooltip::before {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-bottom-color: #8196a9;
}
</style>
